import { lineString } from '@turf/helpers';
import { defaultBounds } from 'common/utils';

export const turfLineString: typeof lineString = (
  value,
  properties,
  options,
) => {
  const coords = (value?.length && value) || defaultBounds;

  if (coords.length === 1) {
    coords.push(coords[0]);
  }

  return lineString(coords, properties, options);
};
